import React from 'react'
import PropTypes from 'prop-types'
import PlaceholderImage from '../PlaceholderImage'

const Ad = props => (
    <PlaceholderImage key={props.id} id={props.id} src={props.src} onClick={props.onClick} />
)

Ad.propTypes = {
    id: PropTypes.string,
    src: PropTypes.string,
    onClick: PropTypes.func,
}

export default Ad



// WEBPACK FOOTER //
// ./src/features/Creatives/components/Feed/components/Viewer/components/Ad/index.js